import React from 'react';
import {PublisherMicrodataSchema} from "./publisher-microdata-schema";
import {ImageObjectMicrodataSchema} from "./image-object-microdata-schema";
import {ReviewedByMicrodataSchema} from "./reviewed-by-microdata-schema";
import {observer} from "mobx-react";

export const WebPageMicroSchema = observer(({metadata, pageUrl}) => {
  if(!metadata.webpageParams || !pageUrl) {
    return null
  }

  const {webpageParams, authorParams, language, sameAsLinks} = metadata
  const {name, description, datePublished, dateModified, image} = webpageParams;

  const containerProps = {
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    itemID: `${pageUrl}/#webpage`,
    style: {display: 'none'}
  }

  return (
    <div {...containerProps}>
      <meta itemProp={"url"} content={pageUrl}/>
      <meta itemProp={"name"} content={name}/>
      <meta itemProp={"description"} content={description}/>
      {datePublished && <meta itemProp={"datePublished"} content={datePublished}/>}
      {dateModified && <meta itemProp={"dateModified"} content={dateModified}/>}
      <meta itemProp={"inLanguage"} content={language}/>

      <div itemProp={"isPartOf"} itemScope itemType={"https://schema.org/WebSite"}>
        <meta itemProp={"url"} content={"https://www.365scores.com/"}/>
        <meta itemProp={"name"} content={"365Scores"}/>
        <meta itemProp={"inLanguage"} content={language}/>
      </div>

      <PublisherMicrodataSchema sameAsLinks={sameAsLinks}/>
      <ImageObjectMicrodataSchema image={image}/>
      <ReviewedByMicrodataSchema pageUrl={pageUrl} authorParams={authorParams}/>
    </div>
  );
});
